import React from 'react';
import './css/NewsCard.css';
import { Link } from 'react-router-dom';

type NewsCardProps = {
    id: string;
    image: string;
    title: string;
    summary: string;
    featured?: boolean;
};

const NewsCard: React.FC<NewsCardProps> = ({ id, image, title, summary, featured = false }) => {
    return (
        <Link to={`/news/${id}`} className={`news-card ${featured ? 'featured' : ''}`}>
            <div className="news-image-container">
                <img src={image} alt={title} className="news-image" />
                {featured && <span className="featured-badge">Шинэ Мэдээ</span>}
            </div>
            <div className="news-content">
                <h3 className="news-title">{title}</h3>
                <p className="news-summary">{summary}</p>
                <div className="read-more-container">
                    <span className="read-more-bubble">Дэлгэрэнгүй</span>
                </div>
            </div>
        </Link>
    );
};

export default NewsCard;